import { createContext, use } from "react";
import type { PaginationContext as PaginationConteType } from "./types";

export const PaginationContext = createContext({} as PaginationConteType);

export const usePaginationContext = () => {
  return use(PaginationContext);
};
